<script lang="ts">
    import SkeletonLoader from '../SkeletonLoader.svelte';

    export let count: number = 3;
</script>

<!-- Mirrors EventCard: border, 2/5 image column, 3/5 content, md:h-[250px] with image -->
<div class="flex flex-col gap-6" data-testid="events-list-skeleton-loader">
    {#each Array(count) as _, i}
        <div
            class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[250px] rounded-lg animate-pulse"
            data-testid="event-card-skeleton"
        >
            <div class="w-full md:w-2/5 h-[160px] md:h-full flex-shrink-0">
                <SkeletonLoader class="w-full h-full !rounded-none" />
            </div>
            <div class="w-full md:w-3/5 p-4 md:p-5 flex flex-col gap-3 justify-between">
                <div class="flex flex-col gap-2">
                    <SkeletonLoader class="h-6 w-3/4" />
                    <SkeletonLoader class="h-4 w-2/5" />
                    <SkeletonLoader class="h-4 w-3/5" />
                    <div class="space-y-2 pt-1">
                        <SkeletonLoader class="h-3 w-full" />
                        <SkeletonLoader class="h-3 w-5/6" />
                    </div>
                </div>
                <div class="flex justify-end pt-2">
                    <SkeletonLoader class="h-10 w-28 rounded-lg" />
                </div>
            </div>
        </div>
    {/each}
</div>
